(function () {
  'use strict';

  function ODRDistributionCtrl (Common, odrDistributionFactory, distributionFactory, odrCalendarFactory,
    whereToFactory, $scope, tmhDynamicLocale, moment, $state, $location, $translate, Translation, $q, productsFactory,
    $timeout) {
    const vm = this;
    let calculatePriceTimeOut;

    function saveModels (terminal, center) {
      odrDistributionFactory.saveModels(odrCalendarFactory.selectedDate, terminal, center);
      $scope.$broadcast('datepickerRefreshView');
    }

    function isSTF () {
      return Common.get('productDelivery', {}).printProvider === 'stralfors';
    }

    function getDeliveryDate () {
      const date = moment();
      date.locale(vm.language);
      return date.format('DD MMMM YYYY');
    }

    function next () {
      if (Common.get('serviceType', 'admail-letter') === 'admail-odr') {
        Common.set('materialDetails', vm.models);
      }

      Common.set('productDelivery.deliveryDate', vm.dateModel);

      $state.go('main.message');
    }

    // this is to render html tags
    function getTranslation (key) {
      return Translation.translate(key).value;
    }

    function changeDeliveryOption (date) {
      const deliveryOverride = odrCalendarFactory.checkDateException(date);
      vm.selectedProduct = odrDistributionFactory.changeDeliveryOption(date, deliveryOverride);
      Common.set('productDelivery', vm.selectedProduct);
      calculatePrice();
    }

    function changeCalendarStyle (key) {
      $scope.$broadcast('datepickerRefreshView');
    }

    function getTerminals () {
      odrDistributionFactory.fetchTerminals()
        .then((res) => {
          odrDistributionFactory.setCenterModel();
          odrDistributionFactory.terminals = res.terminals;
          vm.terminals = odrDistributionFactory.filterTerminals();
          vm.centerModel = odrDistributionFactory.centerModel = odrDistributionFactory.getFormModels('centerModel'); // update again models
          odrDistributionFactory.setTerminalModel();
          vm.terminalModel = odrDistributionFactory.getFormModels('terminalModel');

          vm.selectedProduct.odrDetails.terminal = vm.terminalModel;
          vm.selectedProduct.odrDetails.center = vm.centerModel;
        })
        .catch((err) => {
          console.log(err);
        });
    }

    function filterTerminals () {
      vm.terminals = odrDistributionFactory.filterTerminals();
      vm.terminalModel = odrDistributionFactory.terminalModel = vm.terminals[0];

      saveModels();
      if (!$scope.$$phase) {
        $scope.$apply();
      }
    }

    function activate (res) {
      console.log('ODR Distribution controller activated');
      vm.holidays = odrCalendarFactory.holidays = ((res[0] || {}).result || []);
      vm.dateExceptions = odrCalendarFactory.dateExceptions = ((res[1] || {}).result || []);
      vm.disabledDays = odrCalendarFactory.disabledDays = ((res[2] || {}).result || []);
      odrDistributionFactory.setCalendarModels();

      // models
      // adding this, i don't know the purpose of this, but this is present in the other services
      vm.language = pnTopbar.language;
      vm.zoneCount = Common.get('recipients.zoneCount', undefined);
      vm.addressType = Common.get('recipients.addressType', null);
      vm.odrCenters = odrDistributionFactory.getODRCenters();
      vm.calendarModels = odrDistributionFactory.getCalendarModels();
      vm.products = [];

      // set calendar language
      tmhDynamicLocale.set(pnTopbar.language);

      // methods
      vm.goBack = goBack;
      vm.saveModels = saveModels;
      vm.getDeliveryDate = getDeliveryDate;
      vm.dateMethod = odrCalendarFactory.setDate;
      vm.isProductValid = odrDistributionFactory.isProductValid;
      vm.getFormattedSelectedDate = odrCalendarFactory.getFormattedSelectedDate;
      vm.next = next;
      vm.openHumanyGuide = openHumanyGuide;
      vm.openHumanyAdditional = openHumanyGuideAdditional;
      vm.getSubmissionDeadline = odrCalendarFactory.getSubmissionDeadline;
      vm.getDeliveryTypeKey = odrCalendarFactory.getDeliveryTypeKey;
      vm.checkStandardValidity = odrDistributionFactory.checkStandardValidity;
      vm.cb = changeDeliveryOption; // generic variable to be used to trigger when date changes.
      vm.getSelectedService = odrDistributionFactory.getSelectedService;
      vm.changeCalendarStyle = changeCalendarStyle;
      vm.filterTerminals = filterTerminals;
      vm.getSelectedCenter = odrDistributionFactory.getSelectedCenter;
      vm.displayODRPricing = displayODRPricing;
      vm.filterActiveODRAddons = filterActiveODRAddons;
      vm.addDecimal = addDecimal;
      vm.filterTerminalsViaSearch = odrDistributionFactory.filterTerminalsViaSearch;
      vm.displayBasePriceHeader = displayBasePriceHeader;
      vm.getTranslation = getTranslation;
      vm.getSubmissionDays = odrCalendarFactory.getSubmissionDays;
      vm.calculatePrice = calculatePrice;

      // scope watchers
      $scope.$on('checkYear', function (ev, date) {
        const year = moment(date).year();
        const currentYear = moment(odrCalendarFactory.currentDate).year();
        if (!odrCalendarFactory.years.filter(distributionFactory.filterYear.bind({
          'year': year
        })).length && currentYear < year) {
          odrCalendarFactory.addYear(moment(date).year());
          distributionFactory.getHolidays((pnTopbar.market || 'SE'), pnTopbar.language, year)
            .then(function (res) {
              vm.holidays = odrCalendarFactory.holidays = res.result;
            }, function (err) {
              console.log(err);
            });
        }
      });

      $scope.$on('changeLanguage', function (events, language) {
        vm.language = language;
        tmhDynamicLocale.set(vm.language);
      });

      productsFactory.fetchProducts(true, () => {
        vm.products = whereToFactory.restructureProducts(productsFactory.products);
        getSelectedProduct();
        setPage();
        vm.currency = Common.get('productDelivery').pricingInfo.units;

        if (Common.get('serviceType', 'information') === 'admail-odr') {
          getTerminals();
        }
      });

    }

    function addDecimal (price) {
      let val = parseInt((price || 0)) / 100;
      val = val.toFixed(2);
      val = val.replace('.', ',');
      return val;
    }

    function displayODRPricing (unitType, displayCompound) {
      const productDelivery = Common.get('productDelivery');
      unitType = unitType || odrDistributionFactory.getCurrentUnitType();
      const highTraffic = Common.get('weekInfo', {}).highTraffic;

      const ODRProduct = productDelivery.pricingInfo.deliveryOptions.ODRProducts.find((product) => {
        return product.terminalType === unitType && !!product.highTraffic === highTraffic;
      });

      if (!ODRProduct) {
        return;
      }
      const priceModel = ODRProduct.price_model;

      const weight = Number(productDelivery.weight ? productDelivery.weight.ODR.paper : 0) / 10000.0;
      const compoundPrice = Math.round(priceModel.per_piece + weight * priceModel.per_weight_unit.price);

      return {
        perPiece: displayCompound ? addDecimal(compoundPrice) : addDecimal(priceModel.per_piece),
        perKilo: addDecimal(priceModel.per_weight_unit.price),
        currency: $translate.instant(productDelivery.pricingInfo.units)
      };
    }

    function filterActiveODRAddons () {
      const ODRAddons = Common.get('productDelivery').pricingInfo.deliveryOptions.ODRAddons;
      const recipients = Common.get('recipients');
      const targetType = recipients.targetType;
      const formOfHousing = recipients.odrFilters[targetType].formOfHousing.toLowerCase();
      const hasBlockAddresses = !!recipients.blockAddressCount;

      const filteredAddons = ODRAddons.filter((addon) => {
        if (addon.block) {
          return hasBlockAddresses;
        }
        if (addon.formOfHousing) {
          return addon.formOfHousing.indexOf(formOfHousing) >= 0;
        }
        return false;
      });

      return filteredAddons;
    }

    function getSelectedProduct () {
      const productDelivery = Common.get('productDelivery');
      const deliveryDate = (productDelivery || {}).deliveryDate;
      const deliveryOverride = odrCalendarFactory.checkDateException(deliveryDate);

      if (productDelivery && angular.isDefined(productDelivery)) {
        vm.products.forEach(function (product) {
          if (product.productId === productDelivery.productId) { //products must not share ids
            vm.selectedProduct = odrDistributionFactory.restructureProduct(
              angular.copy(product),
              deliveryDate,
              false,
              deliveryOverride);
            odrDistributionFactory.untouchedProduct = angular.copy(product); // saving it to factory for changeDeliveryOption function

            if (Common.get('serviceType', 'information') === 'admail-odr') {
              odrDistributionFactory.setDimensionLimit(product.pricingInfo.deliveryOptions);
              vm.models = productDelivery.odrDetails.materialDetails;
              vm.terminalModel = odrDistributionFactory.terminalModel = productDelivery.odrDetails.terminal;
              vm.centerModel = odrDistributionFactory.centerModel = productDelivery.odrDetails.center;
              odrDistributionFactory.materialModel = vm.models;

              if (!vm.models) {
                odrDistributionFactory.setDimensionModels();
                // vm.models = odrDistributionFactory.getFormModels('materialModel');
                vm.models = odrDistributionFactory.materialModel;
                vm.selectedProduct.odrDetails.materialDetails = vm.models;
              }

              vm.selectedProduct.odrDetails = productDelivery.odrDetails;
            }
            // including selected date to avoid circular dependency issue
          }
        });
        // no product delivery defined
      } else if (vm.products && vm.products.length) {
        vm.selectedProduct = odrDistributionFactory.restructureProduct(angular.copy(vm.products[0]), null, Common.get('recipients.targetType', 'INDIVIDUALS'));
        odrDistributionFactory.untouchedProduct = angular.copy(vm.products[0]); // saving it to factory for changeDeliveryOption function
        if (Common.get('serviceType', 'information') === 'admail-odr') {
          odrDistributionFactory.setDimensionLimit(vm.products[0].pricingInfo.deliveryOptions);
          odrDistributionFactory.setDimensionModels();
          vm.models = odrDistributionFactory.getFormModels('materialModel');
          vm.selectedProduct.odrDetails = {};
          vm.selectedProduct.odrDetails.materialDetails = vm.models;
        }
      }

      odrCalendarFactory.initializeCalendar(vm.selectedProduct);
      vm.dateClasses = odrCalendarFactory.getCalendarClasses();
      vm.datePickerOptions = odrCalendarFactory.getDatepickerOptions();
      vm.dateModel = odrCalendarFactory.selectedDate;
      vm.selectedProduct = odrDistributionFactory.changeDeliveryOption(vm.dateModel); // this is to make sure that we get the correct delivery option
      Common.set('productDelivery', vm.selectedProduct);
      vm.showContent = true;
      vm.fetchingProducts = false;
    }

    function displayBasePriceHeader () {
      const product = vm.selectedProduct;
      if (!product) {
        return false;
      }
      const printingInfo = product.pricingInfo.printingInfo;
      const deliveryOption = product.pricingInfo.deliveryOptions[0];
      if (printingInfo.basePrice || deliveryOption.addressType === 'ODR') {
        return true;
      }
      return false;
    }

    function getHolidays () {
      return distributionFactory.getHolidays((pnTopbar.market || 'SE'), pnTopbar.language, moment().year());
    }

    function setPage () {
      odrCalendarFactory.isSTF = vm.isSTF = isSTF();
    }

    function goBack () {
      $state.go('main.recipients');
    }

    function openHumanyGuide (faqKey) {
      const faqElem = angular.element('<floating-faq></floating-faq>');

      const key = faqKey || 'additionalServices';
      const langIdKeys = {
        'additionalServices': {
          en: '/13210/',
          sv: '/13209/'
        }
      };
      const langId = langIdKeys[key];

      const widgetName = `w2p-floating-${vm.language}`;
      const humanyName = `${langId[vm.language]}ett-namn`;
      Humany.Widgets.Coordinator.trigger(faqElem, { widgetName: widgetName, activate: true },
        function () {
          Humany.navigate(`w2p-floating-${vm.language}`, humanyName); //TODO: Need to create new article for the ODR products info and its boundaries and use 'type' parameter
        });
    }

    function openHumanyGuideAdditional () {
      const faqElem = angular.element('<floating-faq></floating-faq>');

      const key = 'additionalServices';
      const langIdKeys = {
        'additionalServices': {
          en: '/15172/',
          sv: '/15171/'
        }
      };
      const langId = langIdKeys[key];

      const widgetName = `w2p-floating-${vm.language}`;
      const humanyName = `${langId[vm.language]}Additional-services-for-odr`;
      Humany.Widgets.Coordinator.trigger(faqElem, { widgetName: widgetName, activate: true },
        function () {
          Humany.navigate(`w2p-floating-${vm.language}`, humanyName); //TODO: Need to create new article for the ODR products info and its boundaries and use 'type' parameter
        });
    }

    function getDateExceptions () {
      return odrDistributionFactory.getExceptionDates();
    }

    function getDisabledDays () {
      return odrDistributionFactory.getDisabledDays();
    }

    function getHolidaysAndExceptions () {
      $q.all([
        getHolidays(),
        getDateExceptions(),
        getDisabledDays()
      ])
      .then(activate, function (err) {
        console.log(err);
      });
    }

    function calculatePrice () {
      $timeout.cancel(calculatePriceTimeOut);
      calculatePriceTimeOut = $timeout(() => {
        Common.notifyObserver('web2print.pricing');
      }, 500);
    }

    function checkSession () {
      const serviceType = Common.get('serviceType', null);
      // commenting this for now, we don't have any actual data. uncomment this when recipients page for odr is fully
      // functional
      // var refinedCount = Common.get('recipients.refinedAddressCount');
      const refinedCount = true;
      const paymentStatus = Common.get('paymentStatus', false);

      if (paymentStatus === 'SUCCESS' || !serviceType || !refinedCount) {
        $location.path('/');
        return;
      }

      // setting correct page before calling api so that it wont flicker when loading the page
      setPage();
      getHolidaysAndExceptions();
    }

    // check for required data from previous pages
    checkSession();
  }

  angular.module('web2print.whereTo')
    .controller('ODRDistributionCtrl', ODRDistributionCtrl);

  ODRDistributionCtrl.$inject = ['Common', 'odrDistributionFactory', 'distributionFactory', 'odrCalendarFactory',
    'whereToFactory', '$scope', 'tmhDynamicLocale', 'moment', '$state', '$location', '$translate', 'Translation', '$q',
    'productsFactory', '$timeout'];
})();
